module.exports = __webpack_public_path__ + "static/media/poznaj.adf2cc66.jpg";